import moment from 'moment'

export function formatDate(date) {
  if (!date) return
  return moment(date).format('MM/yyyy')
}

export function formatDate2(date) {
  if (!date) return
  return moment(date).format('MM/yyyy')
}



// WEBPACK FOOTER //
// ./src/common/js/util.js